import React, { useState, useRef } from "react";
import { useAppContext } from "../../context/appContext";
import { FileModal } from "../../components/JobSummary";
import { iterateName } from "../../utils/fileNames";
import {
  MAX_FILE_BYTES,
  previewImage,
} from "../../utils/normalizeImage";

const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "heic"];

function FileFolder() {
  const { job, files, user, isLoading, displayAlert } = useAppContext();

  const [showFileModal, setShowFileModal] = useState(false);
  const [fileItems, setFileItems] = useState([]);

  const maxUserRolesId = 3; // service rep

  const openFolder = (e) => {
    e.preventDefault();

    // check for development/production environment
    let basePath =
      // "https://freelite-my.sharepoint.com/personal/skylights_freelite_onmicrosoft_com/Documents/";
      "https://freelite.sharepoint.com/sites/CompanyDocuments/Shared%20Documents/"
    if (process.env.NODE_ENV === "development") {
      console.log("Development mode!");
      basePath += "IT/JMS3/";
    } else {
      basePath += "FreeliteJMS3/";
    }

    // check for sandbox mode
    let jobPath = job.folder_path;
    console.log("userMode:", user.user_mode);
    if (user.user_mode) {
      jobPath = "sandbox/" + jobPath;
    }
    const url = basePath + jobPath;
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  };

  const handleFileInput = async (e) => {
    const fileList = Array.from(e.target.files);
    console.log("files to upload:", fileList.length);
    const baseFileName = `${job.job_number} Attachment`;
    const assignedNames = [];
    const newItems = [];

    for (const file of fileList) {
      let imagePreview = null;
      const extension = file.name.split(".").pop().toLowerCase();
      const isImage = imageExtensions.includes(extension);
      if (!isImage && file.size > MAX_FILE_BYTES) {
        displayAlert(
          `${file.name} is too large (${(file.size / 1024 / 1024).toFixed(1)} MB). Non-image files must be under 10 MB.`
        );
        continue;
      }
      if (isImage) {
        try {
          imagePreview = await previewImage(file);
        } catch (error) {
          console.error("Error generating preview:", file.name, error);
        }
      }

      // Determine and set new file name
      const takenNames = [...files, ...assignedNames.map((n) => ({ name: n }))];
      const fileName = iterateName(baseFileName, takenNames);
      assignedNames.push(fileName);
      newItems.push({
        fileMetadata: file,
        newName: fileName,
        imagePreview,
        isImage,
      });
    }
    if (newItems.length === 0 && fileList.length > 0) {
      return;
    }

    setFileItems(newItems);
    // Show upload form
    if (newItems.length > 0) {
      setShowFileModal(true);
    }
  };

  const cleanup = () => {
    setFileItems([]);
    setShowFileModal(false);
  };

  return (
    <div className="group one-third">
      <form className="form">
        <h3>File Folder</h3>
          <div className="form-center flex-parent">
            {files.length > 0 ? (
              <div className="subform">
                <div className="files">
                  <table>
                    <tbody>
                      <tr>
                        <th style={{ width: 190 }}>File Name</th>
                        <th style={{ width: 50 }}>Size</th>
                      </tr>
                      {files?.map((file) => {
                        const { id, name, webUrl, size } = file;
                        return (
                          <tr
                            key={id || 0}
                            className=""
                            onClick={() => console.log("open that file...")}
                          >
                            <td>
                              <a
                                href={webUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {name}
                              </a>
                            </td>
                            <td>
                              {/* divide size into kilobytes then into megabytes */}
                              {(size / 1024 / 1000).toFixed(2)} MB
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              "No file folder found for this job."
            )}
          {user.user_roles_id <= maxUserRolesId && (
            <div className="whole form-center">
              <div className="one-half form-center">
                <label className="file-upload btn-block">
                  <span className="btn label-button">
                    {isLoading ? "please wait..." : "Upload File"}
                  </span>
                  <input
                    type="file"
                    name="file"
                    multiple
                    className="btn btn-block"
                    onChange={handleFileInput}
                  />
                </label>
              </div>
              <div className="one-half">
                <button
                  className="btn btn-block"
                  disabled={isLoading}
                  onClick={(e) => openFolder(e)}
                >
                  {isLoading ? "please wait..." : "View Folder"}
                </button>
              </div>
            </div>
          )}
          </div>

      </form>
      {/* ----- Add File Modal ------ */}
      <div
        className={
          showFileModal ? "show-modal modal-container" : "modal-container"
        }
      >
        <div className="group">
          <FileModal
            fileItems={fileItems}
            setFileItems={setFileItems}
            cleanup={cleanup}
          />
        </div>
      </div>
    </div>
  );
}
export default FileFolder;
